<template>
  <div>
    <div class="row">
     <a class="waves-effect waves-light btn blue col s3 " @click="displayDeviceInfo()">Start</a>
      <span class="col s6">{{deviceName}}</span>
      <a v-if="deviceIsConnected" class="waves-effect waves-light btn blue col s3 " @click="reset()">Reset</a>
    </div>
    <div class="row">
      <div class="col s4">X={{accelero_x}}</div>
      <div class="col s4">Y={{accelero_y}}</div>
      <div class="col s4">Z={{accelero_z}}</div>
    </div>
    <div class="row">
      <div class="col s4">Acc={{accelero_distance}}</div>
      <div class="col s4">Max={{accelero_distance_max}}</div>
      <div class="col s4">Total={{accelero_distance_sum}}</div>
    </div>

    <i class="material-icons" :style="{fontSize:accelero_distance*20+'px'}">fitness_center</i>

  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'device',
  props: ['tab'],
  components: { },
  data: function () {
    return {
      user: undefined,
      deviceName: undefined,
      deviceId: undefined,
      deviceIsConnected: false,
      accelero_x: 0,
      accelero_y: 0,
      accelero_z: 0,
      accelero_distance: 0,
      accelero_distance_max: 0,
      accelero_distance_sum: 0
    }
  },
  created () {
    this.user = api.getCurrentUser()
    this.device = {}
  },
  mounted () {
  },
  methods: {
    reset: function () {
      this.accelero_distance_max = 0
      this.accelero_distance_sum = 0
    },
    displayDeviceInfo: function () {
      navigator.bluetooth.requestDevice({ filters: [{ services: ['fitness_machine'] }] })
        .then(device => device.gatt.connect())
        .then(server => server.getPrimaryService('fitness_machine'))
        .then(service => service.getCharacteristic('2d5f3e71-bb02-48c6-9419-263b13ccc6c4'))
        .then(characteristic => characteristic.startNotifications()
          .then(characteristic => {
            characteristic.addEventListener('characteristicvaluechanged', this.handleAccelerometerCharacteristicValueChanged)
            console.log('Notifications have been started.')
            this.deviceName = characteristic.service.device.name
            this.deviceIsConnected = true
          }))
        .catch(error => { console.log(error) })
    },
    handleAccelerometerCharacteristicValueChanged: function (event) {
      var value = event.target.value // array of Float32[3]
      this.accelero_x = value.getFloat32(0, 'littleEndian')
      this.accelero_y = value.getFloat32(4, 'littleEndian')
      this.accelero_z = value.getFloat32(8, 'littleEndian')
      var newAcceleroDistance = Math.pow(Math.abs(Math.pow(this.accelero_x, 3) + Math.pow(this.accelero_y, 3) + Math.pow(this.accelero_z, 3)), 1 / 3)

      this.accelero_distance_max = Math.max(this.accelero_distance_max, newAcceleroDistance)
      this.accelero_distance = newAcceleroDistance
      this.accelero_distance_sum = this.accelero_distance_sum + newAcceleroDistance
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Device.vue